import tickBlanco from "../../img/tickBlanco.svg";

const CircleLineStart = ({ fill, subgroup, order, isCompleted }) => (
  <svg width="30" height="65" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="12" fill={fill} stroke="#458898" strokeWidth="2" />
    <line x1="15" y1="27" x2="15" y2="65" stroke="#458898" strokeWidth="2" strokeLinecap="round" />
    {isCompleted ? (
      <image
        href={tickBlanco}
        x="25%"
        y="14%"
      />
    ) : (
      <text x="15" y="20" textAnchor="middle" fill="#f8f8f8" fontSize="12" fontWeight="bold">
        {subgroup}{order}
      </text>
    )}
  </svg>
);

export default CircleLineStart;